import { UpfrontPaymentSummary } from '@dgx-pr-spa/shared/util';
import { ActionError } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const loadUpfrontPayment = createAction(
  '[Complete Order] Load Upfront Payment'
);

export const loadUpfrontPaymentSuccess = createAction(
  '[Complete Order] Load Upfront Payment Success',
  props<{ payload: UpfrontPaymentSummary }>()
);

export const loadUpfrontPaymentFail = createAction(
  '[Complete Order] Load Upfront Payment Fail',
  props<{ payload: ActionError }>()
);

export const resetUpfrontPayment = createAction(
  '[Complete Order] Reset Upfront Payment'
);

export type UpfrontPaymentActions =
  | typeof loadUpfrontPayment
  | typeof loadUpfrontPaymentSuccess
  | typeof loadUpfrontPaymentFail
  | typeof resetUpfrontPayment;
